import { Arg, Ctx, Directive, Mutation, Resolver } from 'type-graphql'

import { DataOoc, DataOocStatus } from './data-ooc.js'
import { DataOocPatch, NewDataOoc } from './data-ooc-type.js'

@Resolver(DataOoc)
export class DataOocMutation {
  @Directive('@privilege(category: "data-ooc", privilege: "mutation", domainOwnerGranted: true)')
  @Directive('@transaction')
  @Mutation(returns => DataOoc, {
    description:
      'Creates a new out-of-control (OOC) record for quality management. This mutation initiates the corrective action workflow for data samples that exceed control limits.'
  })
  async createDataOoc(@Arg('dataOoc') dataOoc: NewDataOoc, @Ctx() context: ResolverContext): Promise<DataOoc> {
    const { domain, user, tx } = context.state

    const state = dataOoc.state || DataOocStatus.ISSUED
    const history = [
      {
        user: {
          id: user.id,
          name: user.name
        },
        state,
        timestamp: Date.now()
      }
    ]

    return await tx.getRepository(DataOoc).save({
      ...dataOoc,
      state,
      domain,
      history,
      creator: user,
      updater: user
    })
  }

  @Directive('@privilege(category: "data-ooc", privilege: "mutation", domainOwnerGranted: true)')
  @Directive('@transaction')
  @Mutation(returns => DataOoc, {
    description:
      'Updates an out-of-control record with new status, corrective actions, and workflow progress. This mutation tracks the resolution process for quality issues.'
  })
  async updateDataOoc(
    @Arg('id') id: string,
    @Arg('patch') patch: DataOocPatch,
    @Ctx() context: ResolverContext
  ): Promise<DataOoc> {
    const { domain, user, tx } = context.state

    const repository = tx.getRepository(DataOoc)
    const dataOoc = await repository.findOne({
      where: { domain: { id: domain.id }, id }
    })

    const state = patch.state || dataOoc.state

    const history = dataOoc.history || []
    history.push({
      user: {
        id: user.id,
        name: user.name
      },
      state,
      comment: patch.correctiveAction || '',
      timestamp: Date.now()
    })

    const more = {} as any

    if (dataOoc.state !== patch.state) {
      if (patch.state === DataOocStatus.CORRECTED) {
        more.corrector = user
      } else {
        more.corrector = null
      }
    }

    return await repository.save({
      ...dataOoc,
      ...patch,
      ...more,
      state,
      history,
      updater: user
    })
  }

  // @Directive('@privilege(category: "data-ooc", privilege: "mutation", domainOwnerGranted: true)')
  // @Directive('@transaction')
  // @Mutation(returns => [DataOoc], { description: "To modify multiple DataOoc' information" })
  // async updateMultipleDataOoc(
  //   @Arg('patches', type => [DataOocPatch]) patches: DataOocPatch[],
  //   @Ctx() context: ResolverContext
  // ): Promise<DataOoc[]> {
  //   const { domain, user, tx } = context.state

  //   let results = []
  //   const _createRecords = patches.filter((patch: any) => patch.cuFlag.toUpperCase() === '+')
  //   const _updateRecords = patches.filter((patch: any) => patch.cuFlag.toUpperCase() === 'M')
  //   const dataOocRepo = tx.getRepository(DataOoc)

  //   if (_createRecords.length > 0) {
  //     for (let i = 0; i < _createRecords.length; i++) {
  //       const newRecord = _createRecords[i]

  //       const result = await dataOocRepo.save({
  //         ...newRecord,
  //         domain,
  //         creator: user,
  //         updater: user
  //       })

  //       results.push({ ...result, cuFlag: '+' })
  //     }
  //   }

  //   if (_updateRecords.length > 0) {
  //     for (let i = 0; i < _updateRecords.length; i++) {
  //       const newRecord = _updateRecords[i]
  //       const dataOoc = await dataOocRepo.findOneBy({id: newRecord.id})

  //       const result = await dataOocRepo.save({
  //         ...dataOoc,
  //         ...newRecord,
  //         updater: user
  //       })

  //       results.push({ ...result, cuFlag: 'M' })
  //     }
  //   }

  //   return results
  // }

  // @Directive('@privilege(category: "data-ooc", privilege: "mutation", domainOwnerGranted: true)')
  // @Directive('@transaction')
  // @Mutation(returns => Boolean, { description: 'To delete DataOoc' })
  // async deleteDataOoc(@Arg('id') id: string, @Ctx() context: ResolverContext): Promise<boolean> {
  //   const { domain, tx } = context.state

  //   await tx.getRepository(DataOoc).delete({ domain: { id: domain.id }, id })
  //   return true
  // }

  // @Directive('@privilege(category: "data-ooc", privilege: "mutation", domainOwnerGranted: true)')
  // @Directive('@transaction')
  // @Mutation(returns => Boolean, { description: 'To delete multiple dataOocs' })
  // async deleteDataOocs(@Arg('ids', type => [String]) ids: string[], @Ctx() context: ResolverContext): Promise<boolean> {
  //   const { domain, tx } = context.state

  //   await tx.getRepository(DataOoc).delete({
  //     domain,
  //     id: In(ids)
  //   })

  //   return true
  // }
}
